import { ViewTableUtils, type ViewTableColumnsLayoutType } from 'app/main/components/page-layouts';

import buttons from './TagsButtons';

const getTagsTableColumns: ViewTableColumnsLayoutType = ({ settings, t, updateRefresh }) => [
	{
		field: 'tags_id',
		headerName: t('DETAILS_TAGS_FIELD_ID'),
		minWidth: 100,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'tags_title',
		headerName: t('DETAILS_TAGS_FIELD_TITLE'),
		minWidth: 200,
		flex: 1,
		renderCell: ViewTableUtils.renderCellWithTooltip,
		hideable: false
	},
	{
		field: 'user_title',
		headerName: t('DETAILS_TAGS_FIELD_USER_CREATED'),
		minWidth: 200,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'users', uid: row.tags_user_created_uid } })
	},
	{
		field: 'tags_d_created',
		headerName: t('DETAILS_TAGS_FIELD_DATE_CREATED'),
		minWidth: 150,
		renderCell: ViewTableUtils.renderDate
	},
	{
		type: 'actions',
		field: 'actions',
		width: 40,
		renderCell: ({ row }) =>
			ViewTableUtils.renderMenu({
				items: buttons.view?.itemButtons || [],
				buttonProps: { settings, model: row, updateRefresh }
			}),
		sortable: false
	}
];

export default getTagsTableColumns;
